import crApi from '../service/CrApi';

export default class BaseModel {
    private sectionConstants = null;

    public getRaw(params) {
        throw '"getRaw" method is not implemented in a child class.';
    };

    public get(params) {
        throw '"get" method is not implemented in a child class.';
    };

    public async getSectionConstantsv2(section, action, params = {}) {
        let response = await crApi.request(section, action, params);
        const promise = new Promise((resolve) => {
            if (this.sectionConstants == null) {
                // Request from server first time.
                if (response) {
                    let r = response;
                    if (parseInt(r.status) < 1) {
                        return [];
                    }
                    this.sectionConstants = response;
                    resolve(this.sectionConstants);
                };
            } else {
                // Already cached. Resolve immediately.
                resolve(this.sectionConstants);
            }

        });
        return await promise;
    };
}
